<div class="card">
  <div class="card-body" style="padding:10px">
    <div class="row">
      <div class="col-md-12 pt-0">
        <h5 class="border-bottom pb-1 mb-1">{{'componentPages.Meeting Attendance Report' | translate}}</h5>
      </div>
      <div class="col-lg-12">
        <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-xl col-md-6">
            <div class="form-group " >
              <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="attendancefilter['ay']" class="form-control custom-selectbox w-100">
                <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6" *ngIf="this.userDetails['roles'][0]=='ADMIN' || userDetails['roles'][0]=='MISCELLANEOUS_USER'">
            <div class="form-group">
              <label>{{'header.state' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedstate" class="form-control custom-selectbox"
                (change)="showdistrictdropdown(selectedstate)" [disabled]="(this.userDetails['roles'][0]!='ADMIN' && userDetails['roles'][0]!='MISCELLANEOUS_USER') ? true : false" >
                <option value="undefined" disabled>{{'tabledataforstates.selectstate' | translate}}</option>
                <option *ngFor="let state of statelists" value="{{state['uuid']}}">
                  {{'tabledataforstates.' + state.name | translate}}</option>
              </select>
              <!-- <span style="color:red"
                [hidden]="validation[1]">{{'tabledataforstates.pleaseselectstate' | translate}} </span> -->
            </div>
          </div>
          <!-- <div class="col-12 col-xl-6 col-md-6" *ngIf="this.userDetails['roles'][0]
            =='STATE_GANGA_COMMITTEE' || this.userDetails['roles'][0]=='DISTRICT_GANGA_COMMITTEE' ">
            <div class="form-group" >
              <label>{{'header.state' | translate}}<span class="required-field">*</span></label>
              <select  disabled class="form-control custom-selectbox">
                <option>{{'tabledataforstates.' + this.userDetails['loggedUserData']['userProfile']['stateName'] | translate}}</option>
              </select>
            </div>
          </div> -->
          <div class="col-12 col-xl col-md-6" *ngIf="showdistdrop && this.userDetails['roles'][0]!='DISTRICT_GANGA_COMMITTEE' ">
            <div class="form-group">
              <label>{{'header.district' | translate}}<span class="required-field">*</span></label>
              <select placeholder="Select District" [(ngModel)]="selectedDist" (click)="displayempty()"
                class="form-control custom-selectbox" [disabled]="this.userDetails['roles'][0] == 'DISTRICT_GANGA_COMMITTEE' ? true :false">
                <option *ngIf ="this.userDetails['roles'][0] != 'DISTRICT_GANGA_COMMITTEE' " value="undefined" disabled>{{'header.selecttag' | translate}}</option>
                <option  value="ALL">{{'tabledataforstates.all' | translate}}</option>
                <option *ngFor="let data of districtsList" value="{{data.uuid}}">
                  {{'districtsdata.'+ data['name'] | translate}}</option>
              </select>
            </div>
          </div>
          <!-- <div class="col-12 col-xl-6 col-md-6" *ngIf="this.userDetails['roles'][0]=='DISTRICT_GANGA_COMMITTEE' ">
            <div class="form-group" >
              <label>{{'header.district' | translate}}<span class="required-field">*</span></label>
              <select  disabled class="form-control custom-selectbox">
                <option>{{'tabledataforstates.' + this.userDetails['loggedUserData']['userProfile']['stateName'] | translate}}</option>
              </select>
            </div>
          </div> -->
          <!-- <div class="col-12 col-xl col-md-6">
            <div class="form-group">
              <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="attendancefilter['month']" class="form-control custom-selectbox">
                <option *ngIf='selectedDist!= "ALL" ' value="ALL">{{'tabledataforstates.all' | translate}}</option>
                <option  *ngFor="let month of monthsList"  [value]="month.key">
                  {{'monthmaps.' + month['value'] | translate}}</option>
              </select>
            </div>
          </div> -->
          <div class="col-12 col-xl col-md-6">
            <div class="form-group" *ngIf="selectedlanguage=='en'">
              <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
              <ng-multiselect-dropdown placeholder="{{ 'districtsdata.select' | translate}}"
              [data]="monthsList" [settings]="dropdownSettings"
              [(ngModel)]="attendancefilter['month']"
              (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
              (onDeSelect)="onItemDeSelect($event)"
              (onDeSelectAll)="onItemDeSelectAll($event)"
              translation-texts="{'selectAll': ('selectAll' | translate)}">
            </ng-multiselect-dropdown> <!--[(ngModel)]="attendancefilter['month']"-->
            </div>
            <div class="form-group" *ngIf="selectedlanguage=='hi'">
              <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
              <ng-multiselect-dropdown placeholder="{{ 'districtsdata.select' | translate}}"
              [data]="monthsList" [(ngModel)]="attendancefilter['month']" [settings]="hidropdownSettings"
              (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
              (onDeSelect)="onItemDeSelect($event)"
              (onDeSelectAll)="onItemDeSelectAll($event)"
              translation-texts="{'selectAll': ('selectAll' | translate)}">
            </ng-multiselect-dropdown>
            </div>
          </div>
          
          <div class="col-12 col-xl col-md-6" *ngIf = "selectedDist != 'ALL' ">
            <div class="form-group">
              <label>{{'submitdata.designation' | translate }}<span class="required-field"> </span></label>
              <select placeholder="Select Designation"  [(ngModel)]="selectedDesignation" class="form-control custom-selectbox">
                <option value="undefined" disabled>{{ 'dataSubs.selectDesignation' | translate }}</option>
                <option  *ngFor="let designation of designationList"  [value]="designation">
                  {{'meetingModuleUpload.' + designation | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-auto d-flex justify-content-end align-items-end">
            <div class="form-group">
              <label>&nbsp;&nbsp;&nbsp;</label>
              <button class="btn btn-info" (click)="showAttendanceData()" name="submit" *ngIf="selectedDist != 'ALL'" [disabled]="((selectedDist && selectedstate) && this.selectedMonths>0) ? false : true"
                type="button">{{'dataSubs.VIEW' | translate }}</button>
            </div>
          </div>
          <div class="col-auto d-flex justify-content-end align-items-end" *ngIf="showprintData && selectedDist != 'ALL'">
            <div class="form-group">
              <label></label>
              <button class="btn btn-info pointer" (click)="printTable()" type="submit" [disabled]="((selectedDist && selectedstate) && this.selectedMonths>0) ? false : true">{{ 'dataSubs.download' | translate }}</button>
            </div>
          </div>
          <div class="col-auto d-flex justify-content-end align-items-end" *ngIf="selectedDist == 'ALL'">
            <div class="form-group">
              <label></label>
              <button class="btn btn-info pointer" (click)="printAllDIstsTable()" type="submit" [disabled]="((selectedDist && selectedstate) && this.selectedMonths>0) ? false : true">{{ 'dataSubs.download' | translate }}</button>
            </div>
          </div>
        </div>
      </div>      
    </div>

    <div>
      <table class="table text-center" *ngIf="attTableData && attTableData.length > 0" id="content">
        <!-- <thead> -->
          <!-- <tr> -->
            <!-- <th>S.no</th> -->
            <!-- <th>Designation</th> -->
            <!-- <th *ngIf="showMonthCol">Month</th> -->
            <!-- <th>Name</th>
            <th>Contact No.</th> -->
            <!-- <th>Attendance</th> -->
          <!-- </tr> -->
        <!-- </thead> -->
        <!-- <tbody> -->
          <!-- <tr *ngFor="let row of attTableData"> -->
            <!-- <td>{{row['sno']}}</td> -->
            <!-- <td class="alignleft">{{row['designation']}}</td> -->
            <!-- <td *ngIf="showMonthCol">{{row['month']}}</td> -->
            <!-- <td>{{row['name']}}</td>
            <td>{{row['contactno']}}</td> -->
            <!-- <td *ngIf="row['attendance'] == 'yes' ">P</td> -->
            <!-- <td *ngIf="row['attendance'] == 'no' ">A</td> -->
            <!-- <td *ngIf="row['attendance'] == 'yes' ">P</td>
            <td *ngIf="row['attendance'] == 'no' ">A</td> -->
          <!-- </tr> -->
        <!-- </tbody> -->
        <thead>
          <tr>
            <th>{{ 'dataSubs.sno' | translate }}</th>
            <th >{{ 'submitdata.designation' | translate }}</th>
            <th *ngFor="let mon of monthNames"> {{ 'monthmaps.' + mon | translate }}</th>
          </tr>
          <!-- <tr *ngFor="let month of monthsList">
            <th >{{ month.value }}</th>
          </tr> -->
        </thead>
        <tbody>
          <tr *ngFor="let row of attTableData">
            <td>{{ row['sno'] }}</td>
            <td style="text-align: left;">{{ 'meetingModuleUpload.' + row['designation'] | translate }}</td>
            <td *ngFor="let month of monthNames"> {{ 'meetingreport.' + row[month] | translate }} </td>
          </tr>
          <!-- <tr *ngFor="let month of monthsList">
            <td >P</td>
          </tr> -->
        </tbody>
      </table>
      <div *ngIf="(attTableData && attTableData.length == 0)">
        <h3 *ngIf="!(makeempty)">{{ 'infotab.nodata' | translate }}</h3>
      </div>
      <!-- <div *ngIf="makeempty"> </div> -->
    </div>
  </div>
</div>
